const detailsElement = document.getElementById("details");
const statusElement = document.getElementById("status");
const basemapButtons = {
  streets: document.getElementById("basemap-streets"),
  satellite: document.getElementById("basemap-satellite")
};

function clean(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  return String(value);
}

function cleanCurrency(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  const number = Number(value);
  if (Number.isNaN(number)) {
    return clean(value);
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0
  }).format(number);
}

function detailsRow(label, value) {
  return `
    <div class="row">
      <span class="label">${label}</span>
      <span class="value">${value}</span>
    </div>
  `;
}

export function setStatus(text) {
  statusElement.textContent = text;
}

export function bindBasemapButtons(onSelect) {
  for (const [key, button] of Object.entries(basemapButtons)) {
    if (!button) {
      continue;
    }
    button.addEventListener("click", () => onSelect(key));
  }
}

export function setActiveBasemap(name) {
  for (const [key, button] of Object.entries(basemapButtons)) {
    if (!button) {
      continue;
    }
    button.classList.toggle("active", key === name);
    button.setAttribute("aria-pressed", key === name ? "true" : "false");
  }
}

export function renderEmptyState(parcelMinZoom = 12) {
  detailsElement.innerHTML = `
    <article class="card">
      <h2>No Parcel Selected</h2>
      <p>Zoom in and click a parcel boundary to load ownership data.</p>
      <p class="small">Tip: parcel lines appear starting around zoom level ${clean(parcelMinZoom)}.</p>
    </article>
  `;
}

export function renderConfigError(message) {
  detailsElement.innerHTML = `
    <article class="card error">
      <h2>Config Missing</h2>
      <p>${clean(message)}</p>
      <p class="small">Create <code>public/config/dataset.json</code> and set your tile + attribute URLs.</p>
    </article>
  `;
}

export function renderMapError(message) {
  detailsElement.innerHTML = `
    <article class="card error">
      <h2>Map Load Failed</h2>
      <p>${clean(message)}</p>
      <p class="small">Check <code>tiles.pmtilesUrl</code> and confirm the PMTiles file is publicly reachable.</p>
    </article>
  `;
}

export function renderParcelError(message) {
  detailsElement.innerHTML = `
    <article class="card error">
      <h2>Lookup Failed</h2>
      <p>${clean(message)}</p>
    </article>
  `;
}

export function renderParcelDetails(parcel) {
  detailsElement.innerHTML = `
    <article class="card">
      <h2>${clean(parcel.owner_name)}</h2>
      <p class="mono">${clean(parcel.parcel_id)}</p>
      ${detailsRow("County", clean(parcel.county))}
      ${detailsRow("FIPS", clean(parcel.fips))}
      ${detailsRow("Situs Address", clean(parcel.situs_addr))}
      ${detailsRow("Mail Address", clean(parcel.mail_addr))}
      ${detailsRow("Land Value", cleanCurrency(parcel.land_value))}
      ${detailsRow("Improvement Value", cleanCurrency(parcel.imp_value))}
      ${detailsRow("Market Value", cleanCurrency(parcel.mkt_value))}
      ${detailsRow("Tax Year", clean(parcel.tax_year))}
      ${detailsRow("Legal Description", clean(parcel.legal_desc))}
      ${detailsRow("Data Source", clean(parcel.source))}
    </article>
  `;
}
